import InputProps from "./input";

type RadioInputProps = Omit<InputProps, "value"> & {
  checked: boolean;
  name: string;
  label: string;
  value: string | ReadonlyArray<string> | number | undefined;
  fontFamily?: string;
  textSize?: string;
  className?: string;
  isFirst?: boolean; // Used to determine tabindex when no radio is checked
};

const RadioInput: React.FC<RadioInputProps> = (props) => {
  // Base classes for the label (WCAG requires 44x44px minimum touch target)
  const baseClasses = `
        px-4 py-1 min-h-[44px] leading-tight cursor-pointer border border-gray-600
        w-auto text-center flex items-center justify-center
    `
    .trim()
    .replace(/\s+/g, " ");

  // Conditional classes based on checked state
  const checkedClasses = props.checked
    ? "bg-black text-white outline outline-2 outline-gray-600 z-10"
    : "bg-interactive-bg text-black";

  // Default to text-3xl if no textSize is provided
  const textSizeClass = props.textSize || "text-3xl";

  const labelClasses = `${baseClasses} ${checkedClasses} ${textSizeClass} ${props.className || ""}`;

  // For proper radio group keyboard navigation:
  // - Only checked radio should be tabbable (or first if none checked)
  // - Arrow keys handle navigation within the group
  // This is handled by setting tabindex appropriately
  const tabIndex = props.checked || props.isFirst ? 0 : -1;

  return (
    <div className="relative">
      <input
        className="peer sr-only"
        name={props.name}
        type="radio"
        id={props.id}
        value={props.value}
        onChange={props.onChange}
        checked={props.checked}
        tabIndex={tabIndex}
      />
      <label
        className={labelClasses}
        style={{ fontFamily: props.fontFamily }}
        htmlFor={props.id}
      >
        {props.label}
      </label>
    </div>
  );
};

export default RadioInput;
